import { getBackgroundCSS, getBorderCSS, getColorsCSS, getMultiShadowCSS, getSpaceCSS, getTypoCSS } from '../../Components/utils/getCSS';

const Style = ({ attributes, clientId, itemWidth }) => {
	const { columnGap, rowGap, isPopupWidthAsRatio, background, padding, border, shadow, filterBtnTypo, filterBtnColors, filterBtnHoverColors, itemHeight } = attributes;

	const videoGallerySl = `#vgbVideoGallery-${clientId} .vgbVideoGallery`;
	const buttonSl = `${videoGallerySl} .filter button`;
	const fancyMainSl = `.vgbFancyBox-${clientId}`;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${getTypoCSS('', filterBtnTypo)?.googleFontLink}
		${getTypoCSS(buttonSl, filterBtnTypo)?.styles}

		${videoGallerySl}{
			${getBackgroundCSS(background)}
			padding: ${getSpaceCSS(padding)};
			${getBorderCSS(border)}
			box-shadow: ${shadow ? getMultiShadowCSS(shadow) : '0px 25px 30px -20px #0003'};
		}
		${buttonSl}{
			${getColorsCSS(filterBtnColors)}
		}
		${buttonSl}:hover,
		${buttonSl}.current{
			${getColorsCSS(filterBtnHoverColors)}
		}
		${videoGallerySl} .vgbColumnSizer {
			grid-column-gap: ${columnGap}px;
		}
		${videoGallerySl} .videoGallery .galleryItem{
			width: ${itemWidth}px;
			height: ${itemHeight};
			margin-bottom: ${rowGap}px;
		}

		${isPopupWidthAsRatio ? `
			${fancyMainSl} .fancybox-content{
				background: #0000 !important;
			}
			${fancyMainSl} .plyr{
				width: fit-content;
			}
			${fancyMainSl} .plyr .plyr__controls{
				justify-content: flex-start;
			}
		` : ''}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;